import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons';
import { FilledTextFieldProps } from '@mui/material/TextField';
import { FormHelperText } from '@mui/material';
import { Box } from '../box';
import { ColorPalette, TypographySettings } from '../config';

export interface IReadonlyInputProps {
  label?: string;
  value?: string;
  append?: React.ReactNode;
  error?: boolean;
  errorText?: FilledTextFieldProps['helperText'];
  maxRows?: number;
  title?: string;
  onOpenEntity?: () => void;
  disableMarginLeft?: boolean;
}
export function ReadonlyText(props: IReadonlyInputProps) {
  const { label, value = 'Intet indhold', append, error = false, maxRows, errorText = '', title, onOpenEntity, disableMarginLeft } = props;

  // check if value contains line breaks
  const multiline = value ? !!value.match(/\n/g) : false;

  return (
    <Box>
      <Box
        sx={{
          color: ColorPalette.DisabledInputLabel,
          cursor: 'default',
          display: 'inline-flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          padding: disableMarginLeft ? '17px 0 15px 0' : '17px 0 15px 14px',
          position: 'relative',
          verticalAlign: 'top',
          width: '100%',
        }}
      >
        <Box
          sx={{
            color: error ? ColorPalette.HotAurora : 'inherit',
            fontSize: TypographySettings.DefaultFontSize,
            paddingTop: 0,
            marginBottom: 0.5,
            transform: 'translateY(-24px)',
            position: 'absolute',
          }}
        >
          {label}
          {append}
        </Box>
        <Box
          sx={{
            color: ColorPalette.DefaultTextColor,
            paddingLeft: 0,
            fontSize: 14,
            minHeight: 20,
            maxHeight: maxRows ? maxRows * 20 : 'none',
            width: '100%',
            overflow: multiline && maxRows ? 'auto' : 'hidden',
            textOverflow: multiline ? 'clip' : 'ellipsis',
            whiteSpace: 'pre-wrap',
          }}
          title={title ?? value}
        >
          {onOpenEntity ? (
            <Box>
              <FontAwesomeIcon cursor="pointer" icon={faArrowUpRightFromSquare} onClick={onOpenEntity} style={{ paddingRight: '6px' }} />
              {value}
            </Box>
          ) : (
            value
          )}
        </Box>
      </Box>
      {error && <FormHelperText error={error}>{error ? errorText : ''}</FormHelperText>}
    </Box>
  );
}
